module.exports = __webpack_public_path__ + "static/media/PLATINIUM.c0d8a035.png";